import "./KohlerToiletRepair.module.css";
import Header from "@/reusable_sections/Header";
import KohlerHero from "./sections/KohlerHero";
import KohlerGuide from "./sections/KohlerGuide";
import KohlerFaq from "./sections/KohlerFaq";
import Footer from "@/reusable_sections/Footer";
export default function KohlerToiletRepairPage() {
  return <div>
      <Header />
      <KohlerHero />
      <KohlerGuide />
      <KohlerFaq />
      <Footer />
    </div>;
}